export default "__VITE_ASSET__94PGnXxo__"